import { Box, Typography } from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

import { useSearchParamsProvider } from 'context/SearchParamsProvider/SearchParamsProvider';
import FrameCsvExportButton from 'features/Frames/components/Frames/FramesTable/components/FrameCsvExportButton';
import { State } from 'features/Frames/types';
import { statusHeaderWriter } from 'features/Status/utils/statusHeaderWriter';

import useStyles from './FramesPageTableHeader.styles';

type FramesPageTableHeaderProps = {
  state: State;
};

const FramesPageTableHeader = ({ state }: FramesPageTableHeaderProps) => {
  const classes = useStyles();

  const statusHeader = statusHeaderWriter(state);

  const { searchParams } = useSearchParamsProvider();

  return (
    <Box className={classes.header}>
      <Typography variant="body1" fontWeight={600}>
        {statusHeader}
      </Typography>
      <FrameCsvExportButton state={state} searchParams={searchParams} />
    </Box>
  );
};

export default FramesPageTableHeader;
